import { render, staticRenderFns } from "./BetslipFooterCombo.vue?vue&type=template&id=013ee832&scoped=true"
import script from "./BetslipFooterCombo.vue?vue&type=script&lang=js"
export * from "./BetslipFooterCombo.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooterCombo.vue?vue&type=style&index=0&id=013ee832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ee832",
  null
  
)

export default component.exports